// Missing or unrecognized values stay on. Only an explicit false turns the flag off.
export const isEnabledByDefault = (value) => {
    if (value === false) return false;
    if (typeof value === 'string' && value.toLowerCase() === 'false') return false;
    return true;
};
